const workerJobs = {
  DRIVER_SMS_OTP: 'DRIVER_SMS_OTP',
  DRIVER_NOTIFIER: 'DRIVER_NOTIFIER',
  TRACK_TRIP: 'TRACK_TRIP',
  SEND_SMS: 'SEND_SMS',
  SEND_CONSENTS: 'SEND_CONSENTS',
  END_TRIP: 'END_TRIP',
  TRANSPORTER_NOTIFICATION: 'TRANSPORTER_NOTIFICATION',
  RATE_MATRIX: 'RATE_MATRIX',
  NEW_INDENT: 'NEW_INDENT',
  ORDER_EMAIL: 'ORDER_EMAIL',
  ADD_ASSOCIATES: 'ADD_ASSOCIATES',
  FREIGHT_WORKING: 'FREIGHT_WORKING',
  MAIL_EXCEPTION: 'MAIL_EXCEPTION',
  EXCEPTION_CLEAR: 'EXCEPTION_CLEAR',
  FCM_DRIVER_NOTIFICATION: 'FCM_DRIVER_NOTIFICATION',
  RFQ_EXPIRY_TRIGGER: 'RFQ_EXPIRY_TRIGGER',
  REQUEST_QUOTES: 'REQUEST_QUOTES',
  ORDER_SLA_TRIGGER: 'ORDER_SLA_TRIGGER',
  DELAY_AUTO_SWITCH: 'DELAY_AUTO_SWITCH',
  REJECTION_EMAIL_NOTIFICATION: 'REJECTION_EMAIL_NOTIFICATION',
  UPDATE_PAYMENT: 'UPDATE_PAYMENT',
  EMAIL_MODIFIED_PICKLIST: 'EMAIL_MODIFIED_PICKLIST',
  GENERATE_PAYMENT: 'GENERATE_PAYMENT',
  GRN_MATERIAL_UPLOAD: 'GRN_MATERIAL_UPLOAD',
  TRANSPORTER_REASSIGN: 'TRANSPORTER_REASSIGN',
  MULTI_FILE_MATERIAL_UPLOAD: 'MULTI_FILE_MATERIAL_UPLOAD',
  BULK_POD_UPLOAD: 'BULK_POD_UPLOAD',
  AUTO_CANCEL_WORKER: 'AUTO_CANCEL_WORKER',
  AUTO_DELIVER_WORKER: 'AUTO_DELIVER_WORKER',
  BULK_DISPATCH_NOTIFICATION: 'BULK_DISPATCH_NOTIFICATION',
  COMPLETE_TRIP_WORKER: 'COMPLETE_TRIP_WORKER',
  ACROSS_INDENT_MATERIAL_PACKAGE_IMPORT: 'ACROSS_INDENT_MATERIAL_PACKAGE_IMPORT',
  SLA_MAIL_SCHEDULER: 'SLA_MAIL_SCHEDULER',
  BULK_STATUS_UPLOAD: 'BULK_STATUS_UPLOAD',
  UPDATE_FREIGHT_WORKING: 'UPDATE_FREIGHT_WORKING',
  UPDATE_FREIGHT_WORKING_AND_INVOICE_POSTING: 'UPDATE_FREIGHT_WORKING_AND_INVOICE_POSTING',
  TRANSIT_BULK: 'TRANSIT_BULK',
  ERP_CANCEL_ORDER: 'ERP_CANCEL_ORDER',
  ERP_EPOD: 'ERP_EPOD',
  TRANSPORTER_MAIL_NOTIFIER: 'TRANSPORTER_MAIL_NOTIFIER',
  CONSIGNEE_MAIL_NOTIFIER: 'CONSIGNEE_MAIL_NOTIFIER',
  USER_MAIL_NOTIFIER: 'USER_MAIL_NOTIFIER',
  CONTRACT_EXPIRY_NOTIFICATION: 'CONTRACT_EXPIRY_NOTIFICATION',
  PURCHASE_ORDER_EXPIRY_NOTIFICATION: 'PURCHASE_ORDER_EXPIRY_NOTIFICATION',
  VEHICLE_UTILIZATION_NOTIFICATION: 'VEHICLE_UTILIZATION_NOTIFICATION',
  CLIENT_TRANSPORTER_INFRA_SYNCHER: 'CLIENT_TRANSPORTER_INFRA_SYNCHER',
  CONTRACT_DATE_MANAGE_WORKER: 'CONTRACT_DATE_MANAGE_WORKER',
  OPTIMA_EXTRACT_INPUT: 'OPTIMA_EXTRACT_INPUT',
  BASE_DIESEL_PEG_WORKER: 'BASE_DIESEL_PEG_WORKER',
  CLIENT_DIESEL_PEG_WORKER: 'CLIENT_DIESEL_PEG_WORKER',
  TRANSPORTER_DIESEL_PEG_WORKER: 'TRANSPORTER_DIESEL_PEG_WORKER',
  TRANSPORTER_DIESEL_PEG_NOTIFICATION_WORKER: 'TRANSPORTER_DIESEL_PEG_NOTIFICATION_WORKER',
  DIESEL_PEG_EMAIL_NOTIFICATION_WORKER: 'DIESEL_PEG_EMAIL_NOTIFICATION_WORKER',
  EMAIL_SEND: 'EMAIL_SEND',
  RETURN_DEPOT_CREATOR: 'RETURN_DEPOT_CREATOR',
  GENERATE_PAYMENT_V2: 'GENERATE_PAYMENT_V2',
  BASE_WORKER: 'BASE_WORKER',
  POD_FLOW_TO_SAP: 'POD_FLOW_TO_SAP',
  UPDATE_NEW_TRANSPORTER: 'UPDATE_NEW_TRANSPORTER',
  COURIER_SERVICE: 'COURIER_SERVICE',
  COURIER_SERVICE_NOTIFY_FAILED_TRANSACTION: 'COURIER_SERVICE_NOTIFY_FAILED_TRANSACTION',
  COURIER_SERVICE_PICKUP_RESCHEDULE: 'COURIER_SERVICE_PICKUP_RESCHEDULE',
  COURIER_SERVICE_FETCH_LR: 'COURIER_SERVICE_FETCH_LR',
  TRUCK_NOT_REPORTED_NOTIFICATION: 'TRUCK_NOT_REPORTED_NOTIFICATION',
  TRANSIT_DELAY_NOTIFICATION: 'TRANSIT_DELAY_NOTIFICATION',
  OPEN_RFQ_INDENT: 'OPEN_RFQ_INDENT',
  DEDICATED_TRUCK_RUNNING_COUNT_RESET: 'DEDICATED_TRUCK_RUNNING_COUNT_RESET',
  DIRECT_DISPATCH_JOB: 'DIRECT_DISPATCH_JOB',
  DIRECT_DISPATCH_UPDATE: 'DIRECT_DISPATCH_UPDATE',
  WORKFLOW_NOTIFICATION: 'WORKFLOW_NOTIFICATION',
  EXIM_INDENT_NOTIFIER: 'EXIM_INDENT_NOTIFIER',
  ERP_BULK_INDENT: 'ERP_BULK_INDENT',
  VEHICLE_UTILIZATION_CHECK_NOTIFICATION: 'VEHICLE_UTILIZATION_CHECK_NOTIFICATION',
  AUDIT_LOG: 'AUDIT_LOG',
  NOTIFICATION_SERVICE_WORKER: 'NOTIFICATION_SERVICE_WORKER',
  NOTIFICATION_SERVICE_MANAGE_WORKER: 'NOTIFICATION_SERVICE_MANAGE_WORKER',
  S3URL_BASE64_DATA_PUSH: 'S3URL_BASE64_DATA_PUSH',
  ORDER_COUNT_RESET: 'ORDER_COUNT_RESET',
  PURCHASE_ORDER_ENTRY_MOVEMENT: 'PURCHASE_ORDER_ENTRY_MOVEMENT',
  UPDATE_MULTI_LEG_TRANSPORTER: 'UPDATE_MULTI_LEG_TRANSPORTER',
  PR_DEBIT_REVERSAL: 'PR_DEBIT_REVERSAL',
  WALLET_V2_PR_REVERSAL: 'WALLET_V2_PR_REVERSAL',
  UPDATE_INDENT_DISTRIBUTION_COUNT: 'UPDATE_INDENT_DISTRIBUTION_COUNT',
  ERP_BULK_INDENT_UPDATE: 'ERP_BULK_INDENT_UPDATE',
  CALCULATE_INDENT_TOTAL_DISTANCE_TRAVELLED: 'CALCULATE_INDENT_TOTAL_DISTANCE_TRAVELLED',
  COURIER_ASYNC_STATUS: 'COURIER_ASYNC_STATUS',
  COURIER_STATUS_POD_SPLIT_WORKER: 'COURIER_STATUS_POD_SPLIT_WORKER',
  COURIER_STATUS_POD_UPDATE_WORKER: 'COURIER_STATUS_POD_UPDATE_WORKER',
  RETURN_WITH_EPOD: 'RETURN_WITH_EPOD',


  // Pay V2
  E_INVOICE_POSTING_PAYV2: 'E_INVOICE_POSTING_PAYV2',
  FREIGHT_WORKING_PAYV2: 'FREIGHT_WORKING_PAYV2',
  FREIGHT_PROVISION_POSTING_PAYV2: 'FREIGHT_PROVISION_POSTING_PAYV2',
  WALLET_PAYV2: 'WALLET_PAYV2',
  PAYMENT_CHARGE_PAYV2: 'PAYMENT_CHARGE_PAYV2',
  PAYMENT_CREATE_PAYV2: 'PAYMENT_CREATE_PAYV2',
  UPDATE_INVOICES_STATUS: 'UPDATE_INVOICES_STATUS',
  PAYMENT_IMPORT: 'PAYMENT_IMPORT',
  DEDICATED_TRUCK_MIN_GUARANTEE_PAYMENT_GENERATOR: 'DEDICATED_TRUCK_MIN_GUARANTEE_PAYMENT_GENERATOR',
  DELAYED_PAYMENT_PROCESSOR: 'DELAYED_PAYMENT_PROCESSOR',
  FORGOT_PASSWORD: 'FORGOT_PASSWORD',
  PAYMENT_UPDATE_RETURN_INDENT_CANCELLED: 'PAYMENT_UPDATE_RETURN_INDENT_CANCELLED',
  FREIGHT_BILL_POSTING: 'FREIGHT_BILL_POSTING',
  EXIM_SLA: 'EXIM_SLA',
  EXIM_ROAD_LEG_COMPLETE: 'EXIM_ROAD_LEG_COMPLETE',
  WALLET_AUTO_APPROVE: 'WALLET_AUTO_APPROVE',
  EXIM_MASTER_STATUS_UPDATE: 'EXIM_MASTER_STATUS_UPDATE',
  STORE_INVOICE_LOCATION_MOVEMENT: 'STORE_INVOICE_LOCATION_MOVEMENT',
  INTUGINE_SIGNIFY_PAYLOAD_POSTING: 'INTUGINE_SIGNIFY_PAYLOAD_POSTING',
  PAYMENT_FREIGHT_BILL_UPDATE: 'PAYMENT_FREIGHT_BILL_UPDATE',
  ALERT_AND_UPDATE_FREIGHT_BILL_PAYMENTS: 'ALERT_AND_UPDATE_FREIGHT_BILL_PAYMENTS',
  ALERT_AND_UPDATE_INVOICE_MOVEMENTS: 'ALERT_AND_UPDATE_INVOICE_MOVEMENTS',
  TRANSIT_PENALTY_V2: 'TRANSIT_PENALTY_V2',
  ERP_ASSIGN_TRUCK: 'ERP_ASSIGN_TRUCK',
  FCM_EXCEPTION_NOTIFICATION: 'FCM_EXCEPTION_NOTIFICATION',
  // PTL GROUP ACTIONS
  PTL_GROUP_ACTIONS: 'PTL_GROUP_ACTIONS',
  TRIGGER_SHIPMENT_STATUS_UPDATE: 'TRIGGER_SHIPMENT_STATUS_UPDATE',
  ACROSS_INDENT_MATERIAL_IMPORT: 'ACROSS_INDENT_MATERIAL_IMPORT',
  FETCH_VEHICLE_ETA: 'FETCH_VEHICLE_ETA',
  DELETE_IDLE_DRIVER: 'DELETE_IDLE_DRIVER',
  MATERIAL_PACKAGE_MAPPING_MASTER_IMPORT: 'MATERIAL_PACKAGE_MAPPING_MASTER_IMPORT',
  STORE_FREIGHT_INVOICE_DOCS: 'STORE_FREIGHT_INVOICE_DOCS',
  AUTO_DELIVER_FROM_DISPATCH: 'AUTO_DELIVER_FROM_DISPATCH',
  RETURN_APPROVAL_PENDING_NOTIFICATION: 'RETURN_APPROVAL_PENDING_NOTIFICATION',
  RETRIGGER_LR_GENERATION: 'RETRIGGER_LR_GENERATION',
  DIGITAL_SIGNATURE_PENDING_NOTIFICATION: 'DIGITAL_SIGNATURE_PENDING_NOTIFICATION',
  TRUCK_CHANGE_REQUEST_REJECT_NOTIFICATION: 'TRUCK_CHANGE_REQUEST_REJECT_NOTIFICATION',
};

const reportWorkerJobs = {
  INBOUND_STATUS_WORKER: 'INBOUND_STATUS_WORKER',
  PAYMENT_COMPLIANCE_WORKER: 'PAYMENT_COMPLIANCE_WORKER',
  VEHICLE_BIFURCATION_WORKER: 'VEHICLE_BIFURCATION_WORKER',
  EXPORT_REPORT: 'EXPORT_REPORT',
  FREIGHT_PROVISION: 'FREIGHT_PROVISION',
  FREIGHT_PROVISION_PHILIPS_WORKER: 'FREIGHT_PROVISION_PHILIPS_WORKER',
  MIRO_REPORT: 'MIRO_REPORT',
  OPEN_MARKET_PLACEMENT_WORKER: 'OPEN_MARKET_PLACEMENT_WORKER',
  OPTIMA_VS_DISPATCH_MATERIAL_WORKER: 'OPTIMA_VS_DISPATCH_MATERIAL_WORKER',
  TRACK_AND_TRACE_WORKER: 'TRACK_AND_TRACE_WORKER',
  TRANSPORTER_PERFORMANCE_WORKER: 'TRANSPORTER_PERFORMANCE_WORKER',
  TOTAL_DISTANCE_WORKER: 'TOTAL_DISTANCE_WORKER',
  VEHICLE_UTIL_CHECK_WORKER: 'VEHICLE_UTIL_CHECK_WORKER',
  MATERIAL_OVERAGE_SHORTAGE_DAMAGE: 'MATERIAL_OVERAGE_SHORTAGE_DAMAGE',
  GIT_REPORT: 'GIT_REPORT',
  INDENT_STATUS_REPORT: 'INDENT_STATUS_REPORT',
  DELAY_REPORT: 'DELAY_REPORT',
  OPTIMA_REJECTIONS_REPORT: 'OPTIMA_REJECTIONS_REPORT',
  OPTIMA_VENDOR_UPLOAD_REJECTION_LIST: 'OPTIMA_VENDOR_UPLOAD_REJECTION_LIST',
  CONTRACT_HISTORY_IMPORT_WORKER: 'CONTRACT_HISTORY_IMPORT_WORKER',
  HACH_INDENTED_REPORT: 'HACH_INDENTED_REPORT',
  DRIVER_BEHAVIOUR_REPORT_WORKER: 'DRIVER_BEHAVIOUR_REPORT_WORKER',
  EWAY_BILL_ABOUT_TO_EXPIRY: 'EWAY_BILL_ABOUT_TO_EXPIRY',
  TRACK_AND_TRACE_GPS_WORKER: 'TRACK_AND_TRACE_GPS_WORKER',
  TRACK_BULK_FETCH: 'TRACK_BULK_FETCH',

  // PAY V2
  EXPORT_INVOICE_PAYV2: 'EXPORT_INVOICE_PAYV2',
  EXPORT_WALLET_PAYV2: 'EXPORT_WALLET_PAYV2',
  INVOICE_ANNEXURE_MAIL: 'INVOICE_ANNEXURE_MAIL',
  ERP_UPDATE_EXCEPTION_REPORT: 'ERP_UPDATE_EXCEPTION_REPORT',

  API_CLOUDWATCH_METRICS: 'API_CLOUDWATCH_METRICS',
  HYPERTRACK_REPORT: 'HYPERTRACK_REPORT',
};

const rabbitMqJobs = {
  OPTIMA_RUN_JOB: 'OPTIMA_RUN_JOB',
  OPTIMA_RABBITMQ_PRODUCER: 'OPTIMA_RABBITMQ_PRODUCER',
};

const transactionUploadWorkerJobs = {
  INVOICE_INDENT_MATERIALS: 'INVOICE_INDENT_MATERIALS',
  TRIGGER_REJECTION: 'TRIGGER_REJECTION',
  ORDER_BULKUPLOAD: 'ORDER_BULKUPLOAD',
  ERP_MATERIAL_INVOICE_IMPORTER: 'ERP_MATERIAL_INVOICE_IMPORTER',
  DIRECT_DELIVERY_BULK_UPLOAD: 'DIRECT_DELIVERY_BULK_UPLOAD',
  MATERIAL_INVOICE_GRN_BULK_UPLOAD: 'MATERIAL_INVOICE_GRN_BULK_UPLOAD',
  MATERIAL_UPLOAD_POST_PROCESS: 'MATERIAL_UPLOAD_POST_PROCESS',
  LOCATION_MILESTONE_UPLOAD: 'LOCATION_MILESTONE_UPLOAD',
  MATERIAL_INVOICE_GRN_BULK_UPLOAD_JSON: 'MATERIAL_INVOICE_GRN_BULK_UPLOAD_JSON',
  DIRECT_DISPATCH_BULK_UPLOAD: 'DIRECT_DISPATCH_BULK_UPLOAD',
  PRE_PLAN_MATERIAL_UPLOAD: 'PRE_PLAN_MATERIAL_UPLOAD',
  ADVANCE_SHIPMENT_NOTICE_UPLOAD: 'ADVANCE_SHIPMENT_NOTICE_UPLOAD',
  INDENT_POST_NOTIFICATION_DATA: 'INDENT_POST_NOTIFICATION_DATA',
  INDENT_DISTANCE_BULK_UPLOAD_JSON: 'INDENT_DISTANCE_BULK_UPLOAD_JSON',
  GRN_INTERFACE: 'GRN_INTERFACE',
  REACH_AND_RELEASE: 'REACH_AND_RELEASE',
  REACH_AND_RELEASE_EXCEPTION_DATA_UPDATE: 'REACH_AND_RELEASE_EXCEPTION_DATA_UPDATE',
  OPTIMA_UPDATE_EXCEPTION_DATA: 'OPTIMA_UPDATE_EXCEPTION_DATA',
  POST_EXCEPTION: 'POST_EXCEPTION',
  ASN_POST_EVENT_UPDATE_EXCEPTION_DATA: 'ASN_POST_EVENT_UPDATE_EXCEPTION_DATA',
  DEVIATION_NOTIFICATION: 'DEVIATION_NOTIFICATION',
  ERP_TRUCK_IN: 'ERP_TRUCK_IN',
  ERP_TRUCK_OUT: 'ERP_TRUCK_OUT',
  MATERIAL_DISPATCH_THROUGHPUT: 'MATERIAL_DISPATCH_THROUGHPUT',
  MATERIAL_UNLOADING_THROUGHPUT: 'MATERIAL_UNLOADING_THROUGHPUT',
  ERP_MATERIAL_DELETE: 'ERP_MATERIAL_DELETE',
  ERP_LORRY_RECEIPT: 'ERP_LORRY_RECEIPT',
  CHARGEABLE_WEIGHT_BULK_UPLOAD: 'CHARGEABLE_WEIGHT_BULK_UPLOAD',
  UPDATE_UNLOADING_CAPACITY_WORKER: 'UPDATE_UNLOADING_CAPACITY_WORKER',
  CHECK_UNLOADING_CAPACITY: 'CHECK_UNLOADING_CAPACITY',
  TRIGGER_MODIFY_PICKLIST: 'TRIGGER_MODIFY_PICKLIST',

  // PACKING SERVICE
  ERP_MATERIAL_WITH_PACKAGE_IMPORT: 'ERP_MATERIAL_WITH_PACKAGE_IMPORT',
  INDENT_MATERIAL_BULK_DELETE: 'INDENT_MATERIAL_BULK_DELETE',

  // FCM NOTIFICATION SERVICE
  PUSH_USER_NOTIFICATION: 'PUSH_USER_NOTIFICATION',

  // PTL GROUPING ACTIONS
  PTL_GROUP_TRUCK_ASSIGN: 'PTL_GROUP_TRUCK_ASSIGN',
  PTL_GROUP_INDENT_ACCEPT_REJECT: 'PTL_GROUP_INDENT_ACCEPT_REJECT',

  PRE_PLAN_UPDATE_NOTIFICATION_DATA: 'PRE_PLAN_UPDATE_NOTIFICATION_DATA',
  REACH_RELEASE_NOTIFICATION_DATA: 'REACH_RELEASE_NOTIFICATION_DATA',

  VEHICLE_ASSIGNMENT_NOTIFICATION: 'VEHICLE_ASSIGNMENT_NOTIFICATION',
  LR_BULK_UPLOAD: 'LR_BULK_UPLOAD',
  TRANSPORTER_LR_BULK_UPLOAD: 'TRANSPORTER_LR_BULK_UPLOAD',
  ERP_MATERIAL_INVOICE_WITH_LR_IMPORTER: 'ERP_MATERIAL_INVOICE_WITH_LR_IMPORTER',
  ERP_MATERIAL_INVOICE_EPOD: 'ERP_MATERIAL_INVOICE_EPOD',
  ERP_MATERIAL_INVOICE_WITH_PACKAGE_AND_LR_IMPORTER: 'ERP_MATERIAL_INVOICE_WITH_PACKAGE_AND_LR_IMPORTER',
  
  VAHAN_SARATHI_VALIDATION: 'VAHAN_SARATHI_VALIDATION',
};

const hondaTransactionWorker = {
  HONDA_MATERIAL_UPLOAD_POST_PROCESS: 'HONDA_MATERIAL_UPLOAD_POST_PROCESS',
  HONDA_TRIGGER_MODIFY_PICKLIST: 'HONDA_TRIGGER_MODIFY_PICKLIST',
  HONDA_POST_EXCEPTION: 'HONDA_POST_EXCEPTION',
  HONDA_ERP_MATERIAL_INVOICE_IMPORTER: 'HONDA_ERP_MATERIAL_INVOICE_IMPORTER',
  HONDA_ERP_MATERIAL_INVOICE_WITH_PACKAGE_AND_LR_IMPORTER: 'HONDA_ERP_MATERIAL_INVOICE_WITH_PACKAGE_AND_LR_IMPORTER',
};

const emailWorkerJobs = {
  EMAIL_SEND: 'EMAIL_SEND',
  NS_EMAIL_SEND: 'NS_EMAIL_SEND',
};

const nimbusWorkerJobs = {
  SETTINGS_SYNC: 'SETTINGS_SYNC',
};

const packingWorkerJobs = {
  REGENERATE_DOCUMENTS: 'REGENERATE_DOCUMENTS',
  GENERATE_DOCUMENT: 'GENERATE_DOCUMENT',
  TRIGGER_BOOKING: 'TRIGGER_BOOKING',
  PROCESS_PACKING_BOOKING_RESPONSE: 'PROCESS_PACKING_BOOKING_RESPONSE',
  INDENT_SHIPPED: 'INDENT_SHIPPED',
  SHIPPING_MANIFEST: 'SHIPPING_MANIFEST',
  PACKING_AUDIT_LOG: 'PACKING_AUDIT_LOG',
};

const lmsWorkerJobs = {
  UPDATE_CARTON: 'UPDATE_CARTON',
  TRIGGER_CANCEL: 'TRIGGER_CANCEL',
  BACKFLUSH: 'BACKFLUSH',
  CREATE_TASK_ON_INDENTED: 'CREATE_TASK_ON_INDENTED',
};

const courierBulkFetchWorkerJobs = {
  TRACK_BULK_FETCH: 'TRACK_BULK_FETCH',
};

const packingAuditWorkerJob = {
  PACKING_ACTION_AUDIT_LOG: 'PACKING_ACTION_AUDIT_LOG',
  STATUS_UPDATE: 'STATUS_UPDATE',
};

const optimaWorkerJobs = {
  OPTIMA_GROUP_DELIVERIES: 'OPTIMA_GROUP_DELIVERIES',
  OPTIMA_CREATE_INDENTS: 'OPTIMA_CREATE_INDENTS',
  OPTIMA_JOB_STAT_UPDATE: 'OPTIMA_JOB_STAT_UPDATE',
  INDENT_COMBINE: 'INDENT_COMBINE',
  OPTIMA_AUTO_RUN_WORKER: 'OPTIMA_AUTO_RUN_WORKER',
  OPTIMA_JOB_UPDATE: 'OPTIMA_JOB_UPDATE',
  OPTIMA_MOVE_TO_PENDING: 'OPTIMA_MOVE_TO_PENDING',
  OPTIMA_TRIGGER_PICKLIST: 'OPTIMA_TRIGGER_PICKLIST',
  OPTIMA_RUN_COMPLETED_NOTIFICATION: 'OPTIMA_RUN_COMPLETED_NOTIFICATION',
  OPTIMA_DATA_PROCESSOR: 'OPTIMA_DATA_PROCESSOR',
  OPTIMA_OUTPUT_JSON_PROCESSOR: 'OPTIMA_OUTPUT_JSON_PROCESSOR',
  DELIVERY_PICKLIST_WITH_CONSIGNEE: 'DELIVERY_PICKLIST_WITH_CONSIGNEE',
  OPTIMA_MULTI_RUN_DATA_KILLER: 'OPTIMA_MULTI_RUN_DATA_KILLER',
  OPTIMA_MATERIAL_UPLOAD: 'OPTIMA_MATERIAL_UPLOAD',
  OPTIMA_MATERIAL_CATEGORY_UPLOAD: 'OPTIMA_MATERIAL_CATEGORY_UPLOAD',
  OPTIMA_MATERIAL_CATEGORY_VEHICLE_TYPE_UPLOAD: 'OPTIMA_MATERIAL_CATEGORY_VEHICLE_TYPE_UPLOAD',
  OPTIMA_VENDOR_MATERIAL_UPLOAD: 'OPTIMA_VENDOR_MATERIAL_UPLOAD',
  REQUEST_DELIVERY_PICKLIST: 'REQUEST_DELIVERY_PICKLIST',
  DISCARD_OPTIMA_ORDERS: 'DISCARD_OPTIMA_ORDERS',
  OPTIMA_RETRY_FARGATE: 'OPTIMA_RETRY_FARGATE',
  OPTIMA_INDENT_TOPUP: 'OPTIMA_INDENT_TOPUP',
  OPTIMA_DIAGNOSTICS_RUNNER: 'OPTIMA_DIAGNOSTICS_RUNNER',
};

const optimaSpecialWorkerJobs = {
  OPTIMA_INPUT_BUILDER: 'OPTIMA_INPUT_BUILDER',
};

const mdmWorkerJobs = {
  COST_CENTER_BULKUPLOAD: 'COST_CENTER_BULKUPLOAD',
  DEPOT_BULK_UPLOAD: 'DEPOT_BULK_UPLOAD',
  DETENTION_BULKUPLOAD: 'DETENTION_BULKUPLOAD',
  GATE_BULK_UPLOAD: 'GATE_BULK_UPLOAD',
  LOCATION_BULK_UPLOAD: 'LOCATION_BULK_UPLOAD',
  MATERIAL_BULKUPLOAD: 'MATERIAL_BULKUPLOAD',
  CONTRACT_IMPORT_WORKER: 'CONTRACT_IMPORT_WORKER',
  CONTRACT_UPLOAD_WORKER: 'CONTRACT_UPLOAD_WORKER',
  CONTRACT_RESYNC_WORKER: 'CONTRACT_RESYNC_WORKER',
  CONTRACT_VEHICLE_EXCLUDE_WORKER: 'CONTRACT_VEHICLE_EXCLUDE_WORKER',
  CONTRACT_SURGE_THRESHOLD_WORKER: 'CONTRACT_SURGE_THRESHOLD_WORKER',
  CONSIGNEE_TRUCK_EXCLUDE: 'CONSIGNEE_TRUCK_EXCLUDE',
  CONTRACT_TSD_MAP_IMPORT_WORKER: 'CONTRACT_TSD_MAP_IMPORT_WORKER',
  BASE_DIESEL_RATE_IMPORT_WORKER: 'BASE_DIESEL_RATE_IMPORT_WORKER',
  USER_IMPORT: 'USER_IMPORT',
  EXTRA_DROP_OFF_CHARGE_IMPORT_WORKER: 'EXTRA_DROP_OFF_CHARGE_IMPORT_WORKER',
  ERP_MATERIAL_BULKUPLOAD: 'ERP_MATERIAL_BULKUPLOAD',
  ERP_TRANSPORTER_BULKUPLOAD: 'ERP_TRANSPORTER_BULKUPLOAD',
  ERP_CONSIGNEE_BULKUPLOAD: 'ERP_CONSIGNEE_BULKUPLOAD',
  ASSOCIATED_MATERIAL_BULKUPLOAD: 'ASSOCIATED_MATERIAL_BULKUPLOAD',
  TRANSPORTER_BULKUPLOAD: 'TRANSPORTER_BULKUPLOAD',
  VEHICLE_UPLOAD: 'VEHICLE_UPLOAD',
  VEHICLE_DETAIL_UPLOAD: 'VEHICLE_DETAIL_UPLOAD',
  DEDICATED_TRUCK_UPLOAD: 'DEDICATED_TRUCK_UPLOAD',
  BILL_DISCOUNT_UPLOAD: 'BILL_DISCOUNT_UPLOAD',
  CLEARING_HOUSE_AGENT_UPLOAD: 'CLEARING_HOUSE_AGENT_UPLOAD',
  CONTAINER_BULKUPLOAD: 'CONTAINER_BULKUPLOAD',
  PORT_BULKUPLOAD: 'PORT_BULKUPLOAD',
  ERP_DRIVER_BULKUPLOAD: 'ERP_DRIVER_BULKUPLOAD',
  VEHICLE_BULK: 'VEHICLE_BULK',
  VEHICLE_DETAIL_BULK_UPLOAD: 'VEHICLE_DETAIL_BULK_UPLOAD',
  TRANSPORTATION_DB_BULK_UPLOAD: 'TRANSPORTATION_DB_BULK_UPLOAD',
  PURCHASE_ORDER_UPLOAD: 'PURCHASE_ORDER_UPLOAD',
  FETCH_PURCHASE_ORDER: 'FETCH_PURCHASE_ORDER',
  PACKAGE_MASTER_IMPORT: 'PACKAGE_MASTER_IMPORT',
  UPDATE_MATERIAL_ASSOCIATE_USER: 'UPDATE_MATERIAL_ASSOCIATE_USER',
  MATERIALCATEGORY_BULKUPLOAD: 'MATERIALCATEGORY_BULKUPLOAD',
  ERP_MATERIAL_WITH_PACKAGE_IMPORT: 'ERP_MATERIAL_WITH_PACKAGE_IMPORT',
  UPLOAD: 'UPLOAD',
  CONSIGNMENT_BULK_IMPORT_WORKER: 'CONSIGNMENT_BULK_IMPORT_WORKER',
  SET_LAT_AND_LONG: 'SET_LAT_AND_LONG',
  // MDM-v2
  MDM_SPLIT_WORKER: 'MDM_SPLIT_WORKER',
  MDM_VALIDATION_WORKER: 'MDM_VALIDATION_WORKER',
  MDM_VALIDATION_DB_UPDATE_WORKER: 'MDM_VALIDATION_DB_UPDATE_WORKER',
  ACTIVITY_TIME_BULK_UPLOAD: 'ACTIVITY_TIME_BULK_UPLOAD',
  ORDER_CONTRACT_UPDATE: 'ORDER_CONTRACT_UPDATE',
  TRANSSHIPMENT_BULK_UPLOAD: 'TRANSSHIPMENT_BULK_UPLOAD',
  DESTINATION_CHARGES_UPLOAD: 'DESTINATION_CHARGES_UPLOAD',
  // Pay Settlement
  PAY_SETTLEMENT_UPLOAD: 'PAY_SETTLEMENT_UPLOAD',
};

module.exports = {
  workerJobs,
  reportWorkerJobs,
  rabbitMqJobs,
  emailWorkerJobs,
  nimbusWorkerJobs,
  packingWorkerJobs,
  lmsWorkerJobs,
  courierBulkFetchWorkerJobs,
  packingAuditWorkerJob,
  optimaWorkerJobs,
  transactionUploadWorkerJobs,
  mdmWorkerJobs,
  optimaSpecialWorkerJobs,
  hondaTransactionWorker,
};
